import React from 'react';
import { Dialog } from 'primereact/dialog';
import { UserPageProfile } from '../../../../pages/user-page/pages/profile/user-page-profile';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';

interface UserProfileDialogProps {
  visible: boolean;
  onHide: () => void;
  user: UserSummaryType | undefined;
}

export const UserProfileDialog: React.FC<UserProfileDialogProps> = ({
  visible,
  onHide,
  user,
}) => {
  return (
    <Dialog
      header="פרופיל משתמש"
      visible={visible}
      onHide={onHide}
      style={{
        width: '90vw',
        maxWidth: '1200px',
      }}
      contentStyle={{
        padding: '0',
        maxHeight: '80vh',
        overflow: 'auto',
      }}
      modal
      dismissableMask
      draggable={false}
      resizable={false}
    >
      {user && <UserPageProfile user={user} displayChangePassword={true} />}
    </Dialog>
  );
};
